
import { Component, Mixins } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import dayjs from "dayjs";
import { getTongueApiOverview } from "@/api/tongue";
import ETable from "@/components/ETable.vue";

@Component({
  components: {
    ETable,
  },
})
export default class TongueApiStatistics extends Mixins(loading, tablePagination, Resize) {
  queryForm = {
    name: "",
  };

  tableData: Array<any> = [];
  itemTotal = 0;
  columns = [
    { label: "品牌方ID", prop: "id", align: "center", minWidth: 120 },
    { label: "品牌方名称", prop: "name", align: "center", minWidth: 180 },
    { label: "API门店", prop: "apiStoreName", align: "center", minWidth: 180 },
    { label: "当前API QPS", prop: "tongueApiQps", align: "center", minWidth: 130 },
    { label: "本周期充值次数", prop: "totalCount", align: "center", minWidth: 130 },
    { label: "本周期剩余次数", prop: "remainCount", align: "center", minWidth: 130 },
    { label: "本周期到期时间", prop: "expireTime", align: "center", minWidth: 180 },
    { label: "累计充值次数", prop: "totalCountAll", align: "center", minWidth: 130 },
    { label: "累计使用次数", prop: "totalUseCount", align: "center", minWidth: 130 },
  ];

  mounted() {
    this.windowResize(260);
    this.getData();
  }

  resetPages() {
    this.currentPage = 1;
  }

  handleSearch() {
    this.resetPages();
    this.getData();
  }

  goMerchantList(row: any) {
    if (!row?.name) return;
    this.$router.push({
      path: "/merchantList",
      query: {
        name: encodeURIComponent(row.name),
      },
    });
  }

  getData() {
    this.showLoading();
    getTongueApiOverview({
      merchantName: this.queryForm.name || undefined,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
    })
      .then((res: any) => {
        const { list = [], total = 0 } = res.data || {};
        this.itemTotal = total;
        this.tableData = list.map((item: any) => {
          return {
            ...item,
            totalCount: item.totalCount < 0 ? "-" : item.totalCount,
            remainCount: item.remainCount < 0 ? "-" : item.remainCount,
            expireTime: item.expireTime == '9999-12-31 23:59:59' ? "-" : item.expireTime,
            totalCountAll: item.totalCountAll < 0 ? "-" : item.totalCountAll,
            totalUseCount: item.totalUseCount < 0 ? "-" : item.totalUseCount,
          }
        });
      })
      .finally(() => {
        this.hideLoading();
      });
  }
}
